import { IntlShape, defineMessages } from 'react-intl';

import { TJourneyStatus, JourneyStatusEnum } from '@/modules/journey/model';

const STATUSES = defineMessages<TJourneyStatus>({
  [JourneyStatusEnum.new]: {
    defaultMessage: 'New',
    id: 'mk2cxg',
    description: 'Journey status',
  },
  [JourneyStatusEnum.accepted]: {
    defaultMessage: 'Reserved',
    id: 'unPG1u',
    description: 'Journey status',
  },
  [JourneyStatusEnum.on_the_way]: {
    defaultMessage: 'On the way',
    id: 'xHwCZt',
    description: 'Journey status',
  },
  [JourneyStatusEnum.arrived]: {
    defaultMessage: 'Arrived',
    id: 'O8bqC7',
    description: 'Journey status',
  },
  [JourneyStatusEnum.no_show]: {
    defaultMessage: 'No show',
    id: 'z8K/5P',
    description: 'Journey status',
  },
  [JourneyStatusEnum.serving]: {
    defaultMessage: 'Passenger on board',
    id: 'uLDfZd',
    description: 'Journey status',
  },
  [JourneyStatusEnum.done]: {
    defaultMessage: 'Done',
    id: 'kFq+2R',
    description: 'Journey status',
  },
  [JourneyStatusEnum.cancelled]: {
    defaultMessage: 'Cancelled',
    id: '+VTXj5',
    description: 'Journey status',
  },
  [JourneyStatusEnum.failed]: {
    defaultMessage: 'Failed',
    id: 'qiM7R1',
    description: 'Journey status',
  },
  [JourneyStatusEnum.looking_for_drivers]: {
    defaultMessage: 'Looking for chauffeur',
    id: 'WzwGLS',
    description: 'Journey status',
  },
  [JourneyStatusEnum.car_not_found]: {
    defaultMessage: 'Vehicle not found',
    id: 'A0d3oI',
    description: 'Journey status',
  },
});

const renderStatus = (status: TJourneyStatus, intl: IntlShape): string => {
  if (status in STATUSES) {
    return intl.formatMessage(STATUSES[status]);
  }

  return '–';
};

export { renderStatus };
